import React from 'react'
import '../../App.css'
import './Partners.css'
import FoodChain from '../../images/foodvaluechain.jpg'
import Par1 from '../../images/ADM.svg'
import Par2 from '../../images/bunge.svg'
import Par3 from '../../images/cargill.svg'
import Par4 from '../../images/LDC.svg'
import Par5 from '../../images/mondelez.svg'
import Par6 from '../../images/nestle.svg'
import Par7 from '../../images/mars.png'
import Par8 from '../../images/pepsico.png'
import Par9 from '../../images/plc.png'
import Par10 from '../../images/unilever.png'
import Par11 from '../../images/kelloggs.png'
import Par12 from '../../images/danone.png'
import Par13 from '../../images/cocacola.png'
import Par14 from '../../images/generalmills.png'
import Par15 from '../../images/theworldbank.png'
import Par16 from '../../images/wfp.svg'
import Par17 from '../../images/IFPRI.svg'
import Par18 from '../../images/FAO.svg'
import Par19 from '../../images/godan.png'
import Par20 from '../../images/USDA.svg'
import Par21 from '../../images/AMIS.png'
import Par22 from '../../images/CMEW.png'
import Par23 from '../../images/IGC.png'
import Par24 from '../../images/CME.svg'
import Par25 from '../../images/CNBC.png'
import Par26 from '../../images/barclay.svg'
import Par27 from '../../images/NYSE.png'
import Par28 from '../../images/nasdag.svg'
import Par29 from '../../images/invesco.png'
import Par30 from '../../images/CFTC.svg'
import Par31 from '../../images/bloomberg.svg'
import Par32 from '../../images/ipath.png'
import Par33 from '../../images/teucrium.png'
import Par34 from '../../images/dataafrica.png'
import Par35 from '../../images/harvest.png'
import Par36 from '../../images/ice.png'
import Par37 from '../../images/openmarkets.png'
import Par38 from '../../images/ETN.png'

import { Title } from '../Title'

import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'

export const Partners = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--eigth'
      >
        Partners
      </BackgroundSection>
      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Food Value Chain
        </Title>
        <div className='foodchain-pic-container'>
          <img className='foodchain' src={FoodChain} alt='Food Value Chain' />
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--contwo'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Food Industry Stakeholders
        </Title>
        <div className='abcd-container'>
          <Title
            className='title'
            titleStyle='title--pars'
            titleSize='title--small'
          >
            ABCD Commodity Traders
          </Title>
          <div className='abcd-pic-container'>
            <img className='par1' src={Par1} alt='Partners' />
            <img className='par2' src={Par2} alt='Partners' />
            <img className='par3' src={Par3} alt='Partners' />
            <img className='par4' src={Par4} alt='Partners' />
          </div>
        </div>
        <div className='par-pic-container'>
          <img className='par5' src={Par5} alt='Partners' />
          <img className='par6' src={Par6} alt='Partners' />
          <img className='par7' src={Par7} alt='Partners' />
          <img className='par8' src={Par8} alt='Partners' />
          <img className='par9' src={Par9} alt='Partners' />
          <img className='par10' src={Par10} alt='Partners' />
          <img className='par11' src={Par11} alt='Partners' />
          <img className='par12' src={Par12} alt='Partners' />
          <img className='par13' src={Par13} alt='Partners' />
          <img className='par14' src={Par14} alt='Partners' />
          <img className='par15' src={Par15} alt='Partners' />
          <img className='par16' src={Par16} alt='Partners' />
          <img className='par17' src={Par17} alt='Partners' />
          <img className='par18' src={Par18} alt='Partners' />
          <img className='par19' src={Par19} alt='Partners' />
          <img className='par20' src={Par20} alt='Partners' />
          <img className='par21' src={Par21} alt='Partners' />
          <img className='par22' src={Par22} alt='Partners' />
          <img className='par23' src={Par23} alt='Partners' />
          <img className='par24' src={Par24} alt='Partners' />
          <img className='par25' src={Par25} alt='Partners' />
          <img className='par26' src={Par26} alt='Partners' />
          <img className='par27' src={Par27} alt='Partners' />
          <img className='par28' src={Par28} alt='Partners' />
          <img className='par29' src={Par29} alt='Partners' />
          <img className='par30' src={Par30} alt='Partners' />
          <img className='par31' src={Par31} alt='Partners' />
          <img className='par32' src={Par32} alt='Partners' />
          <img className='par33' src={Par33} alt='Partners' />
          <img className='par34' src={Par34} alt='Partners' />
          <img className='par35' src={Par35} alt='Partners' />
          <img className='par36' src={Par36} alt='Partners' />
          <img className='par37' src={Par37} alt='Partners' />
          <img className='par38' src={Par38} alt='Partners' />
        </div>
      </ContainerSection>
    </>
  )
}
